import { ModalServices } from '@/services/ModalServices';
import store from '@/store';
import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/reviewRules',
            name: 'village_reviewRules',
            component: () => import("./views/reviewRules.vue"),
            meta: {
                hasBar: true,
            }
        },
        {
            path: '/village/reviewRulesComplete',
            name: 'village_reviewRulesComplete',
            component: () => import("./views/reviewRulesComplete.vue"),
            meta: {
            }
        },
        {
            path: '/village/review',
            name: 'village_review',
            component: () => import("./views/review.vue"),
            meta: {
            },
            beforeEnter: (to, from, next) => {
                if(store.state.isInThisVillage || store.state.user.fullAccess)
                    next();
                else
                    ModalServices.notInVillageModal();
            }
        },
    ];
};